export const EDIT_TITLE = 'Adicionar Dados de Retorno';
export const READ_TITLE = 'Dados de Retorno';
export const TOOLTIP = 'Adicionar Dados de Retorno';

export const ROUTE_NAME_INCLUIR = 'Adicionar Dados de Retorno';
export const ROUTE_NAME_INSPECIONAR = 'Inspeção de Dados de Retorno';

export const NOME_FIELD = 'Nome';
export const VALOR_FIELD = 'Valor';
